// Global i18n dictionary for both marketing/dashboard UI and public customer flow.
// Supported languages: IT, EN, ES, FR, DE

export const LANGUAGES = [
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

export const translations = {
  it: {
    platform_done: "Recensione pubblicata",
    platform_tap_to_publish: "Tocca per incollare e pubblicare",
    platforms_list_title: "Pubblica la tua recensione",
    platforms_list_desc: "Tocca una piattaforma: il testo viene copiato, incollalo e pubblica. Poi torna qui per la successiva.",
    platforms_list_locked: "Scegli le stelle e scrivi almeno 20 caratteri per sbloccare le piattaforme.",
    platforms_progress: "{done} di {total} piattaforme completate",
    finish_now_btn: "Ho finito",
    platform_confirm_title: "Hai pubblicato su {platform}?",
    platform_confirm_desc: "Conferma se la piattaforma ha ricevuto la tua recensione, così la segniamo come completata.",
    platform_confirm_yes: "Sì, pubblicata",
    platform_confirm_no: "Non ancora",
    // Landing
    nav_login: "Accedi",
    nav_signup: "Inizia gratis",
    nav_dashboard: "Dashboard",
    hero_badge: "Per Tour Operator, Hotel, Ristoranti & Servizi",
    hero_title_1: "Una recensione,",
    hero_title_2: "tutte le piattaforme.",
    hero_desc: "Genera un link unico per Tour Operator, Hotel, Ristoranti e Servizi. Il tuo cliente scrive una sola recensione e la pubblichiamo insieme su TripAdvisor, Google, Trustpilot e Facebook.",
    hero_cta: "Prova gratis 1 giorno",
    hero_trial_note: "1 giorno di prova gratuita",
    feat_unique_link: "Link unico per tour",
    feat_5_lang: "5 lingue integrate",
    feat_analytics: "Analytics in tempo reale",
    hero_card_today: "+3 recensioni oggi",
    hero_card_completion: "tasso di completamento",
    for_whom_kicker: "Per chi è",
    for_whom_title: "Pensato per chi vive di reputazione online",
    for_whom_tour: "Tour Operator",
    for_whom_tour_desc: "Escursioni, esperienze, guide",
    for_whom_hotel: "Hotel & B&B",
    for_whom_hotel_desc: "Strutture ricettive di ogni misura",
    for_whom_rest: "Ristoranti",
    for_whom_rest_desc: "Locali, pizzerie, trattorie",
    for_whom_serv: "Servizi",
    for_whom_serv_desc: "Professionisti e attività locali",
    pricing_kicker: "Piani & Prezzi",
    pricing_title: "Scegli in base alle piattaforme",
    pricing_subtitle: "Prova gratis per 1 giorno. Cambia piano o annulla in qualsiasi momento.",
    cycle_monthly: "Mensile",
    cycle_semiannual: "Semestrale",
    cycle_annual: "Annuale",
    plan_popular: "Popolare",
    plan_starter: "Starter",
    plan_starter_desc: "Iniziare a raccogliere recensioni",
    plan_growth: "Growth",
    plan_growth_desc: "Il più scelto dai tour operator",
    plan_pro: "Pro",
    plan_pro_desc: "Copri tutte le piattaforme principali",
    plan_business: "Business",
    plan_business_desc: "Multi-canale + supporto prioritario",
    per_month: "/mese",
    billed_monthly: "Fatturazione mensile",
    billed_every_months: "ogni {n} mesi",
    billed_annually: "fatturato annualmente",
    plan_feat_platforms: "Fino a {n} piattaforme",
    plan_feat_tours: "Tour / punti vendita illimitati",
    plan_feat_multilang: "Pagina cliente multilingua (5 lingue)",
    plan_feat_smart: "Smart Filter feedback privato",
    plan_feat_analytics: "Dashboard analytics",
    plan_feat_priority: "Supporto prioritario",
    plan_feat_credits: "{n} crediti al mese",
    plan_feat_photos: "Foto sulle recensioni (max 3)",
    plan_cta_start: "Prova gratis 1 giorno",
    plan_cta_dashboard: "Vai al dashboard",
    pricing_footer: "Prezzi in USD. IVA esclusa dove applicabile. Cancellazione in qualsiasi momento.",
    credits_title: "Crediti disponibili",
    credits_used_of: "{used} / {total} crediti utilizzati",
    credits_reset: "Rinnovo il {date}",
    credits_no_sub: "Piano gratuito — abbonati per ottenere più crediti",
    credits_upgrade: "Vedi piani",
    how_credits_title: "Come funzionano i crediti",
    how_credits_desc: "I crediti si consumano al completamento di ogni recensione, in base al canale usato e al numero di piattaforme configurate sul tour.",
    credit_cost_email: "Link via email / WhatsApp / SMS",
    credit_cost_qr: "Link via QR Code",
    credit_cost_photos: "Recensione con foto allegate",
    credit_per_platform: "{n} crediti / piattaforma",
    credit_formula: "Costo totale = costo × numero di piattaforme configurate sul tour",
    credits_exhausted_title: "Crediti esauriti",
    credits_exhausted_desc: "Questo tour operator ha esaurito i crediti del mese. Torna più tardi!",
    photos_title: "Aggiungi foto (opzionale)",
    photos_desc: "Massimo 3 foto. Verranno mostrate insieme al testo quando pubblicherai la recensione.",
    photos_add: "Carica foto",
    photos_remove: "Rimuovi",
    photos_uploading: "Caricamento…",
    photos_max_reached: "Massimo 3 foto",
    photos_download_note: "Prima di pubblicare, salva le foto sul telefono per caricarle su ogni piattaforma.",
    footer_line: "Una recensione, tutte le piattaforme.",

    // Auth
    auth_login_title: "Bentornato",
    auth_login_sub: "Accedi al tuo dashboard.",
    auth_register_title: "Crea il tuo account",
    auth_register_sub: "Inizia a raccogliere recensioni ovunque. 1 giorno di prova gratuita.",
    field_email: "Email",
    field_password: "Password",
    field_password_hint: "Password (min 6 caratteri)",
    field_business: "Nome azienda",
    field_business_ph: "Il tuo tour operator / hotel / ristorante",
    login_submit: "Accedi",
    login_submitting: "Accesso in corso…",
    register_submit: "Crea account",
    register_submitting: "Creazione in corso…",
    no_account: "Non hai un account?",
    have_account: "Hai già un account?",
    signup_link: "Registrati",
    login_link: "Accedi",
    auth_side_title: "Ogni cliente, una recensione ovunque.",
    auth_side_sub: "Aumenta la reputazione online della tua attività.",
    toast_welcome_back: "Bentornato!",
    toast_welcome: "Benvenuto!",

    // Dashboard
    sidebar_dashboard: "Dashboard",
    sidebar_tours: "Tours",
    sidebar_restaurants: "Ristoranti",
    sidebar_hotels: "Hotel",
    sidebar_services: "Servizi",
    sidebar_logout: "Esci",
    sidebar_connected_as: "Connesso come",
    dashboard_hi: "Ciao",
    dashboard_title: "Dashboard",
    new_tour_btn: "Collega Piattaforme",
    kpi_tours: "Tour attivi",
    kpi_clicks: "Link aperti",
    kpi_completions: "Completati",
    kpi_conversion: "Conversion rate",
    chart_platforms_title: "Click per piattaforma",
    chart_platforms_sub: "Aggregato di tutti i tour",
    your_tours: "I tuoi tour",
    view_all: "Vedi tutti",
    loading: "Caricamento…",
    no_tours_yet: "Non hai ancora tour.",
    create_first: "Crea il primo",
    events_opens: "aperti",
    events_completed: "completati",

    // Tours list
    tours_title: "I tuoi tour",
    tours_subtitle: "Gestisci i tour e i link delle piattaforme di recensione.",
    search_ph: "Cerca…",
    no_tours: "Nessun tour",
    no_tours_desc: "Crea il tuo primo tour e ottieni un link unico da inviare ai clienti.",
    create_tour: "Crea tour",
    n_platforms: "{n} piattaforme",
    no_description: "Nessuna descrizione",
    copy_link_btn: "Copia link",
    toast_link_copied: "Link copiato negli appunti",
    toast_link_customer_copied: "Link copiato! Invialo al tuo cliente.",
    del_confirm_title: "Eliminare \"{name}\"?",
    del_confirm_desc: "Questa azione è permanente. Anche le statistiche verranno cancellate.",
    cancel: "Annulla",
    delete: "Elimina",
    toast_tour_deleted: "Tour eliminato",

    // Tour editor
    back_to_tours: "Torna ai tour",
    new_tour_title: "Collega Piattaforme",
    edit_tour_title: "Modifica tour",
    copy_customer_link: "Copia link cliente",
    tour_name: "Nome del tour",
    tour_name_ph: "es. Escursione Amalfi al tramonto",
    tour_description: "Descrizione (opzionale)",
    tour_description_ph: "Breve descrizione visibile al cliente…",
    platforms_title: "Link alle piattaforme di recensione",
    platforms_desc: "Inserisci il link di scrittura recensione specifico per questo tour su ogni piattaforma. Lascia vuoto per non mostrarla al cliente.",
    smart_filter_title: "Smart Filter",
    smart_filter_desc: "Se il cliente lascia una recensione con meno stelle della soglia, viene reindirizzato a un modulo di feedback privato invece di essere invitato a pubblicare online.",
    smart_filter_label: "Soglia minima di stelle per la pubblicazione pubblica",
    smart_filter_option: "{n}★ e più",
    smart_filter_hint_all: "Tutte le recensioni verranno indirizzate alle piattaforme pubbliche.",
    smart_filter_hint: "Con meno di {n} stelle il cliente vedrà solo il modulo privato.",
    feedback_title: "Feedback privati ricevuti",
    feedback_empty: "Nessun feedback privato ancora. Quando un cliente lascerà una valutazione bassa, vedrai qui il suo messaggio.",
    how_it_works: "Come funziona",
    how_1: "Salva il tour e ottieni il link unico",
    how_2: "Invialo al cliente via WhatsApp, email o SMS",
    how_3: "Il cliente scrive la recensione una volta",
    how_4: "L'app copia il testo e apre le piattaforme in sequenza",
    save_tour: "Salva tour",
    saving: "Salvo…",
    toast_tour_created: "Tour creato!",
    toast_saved: "Salvato",
    name_required: "Il nome del tour è obbligatorio",

    // Public customer flow (kept from previous i18n)
    welcome_hi: "Ciao!",
    welcome_sub: "Grazie per aver scelto",
    welcome_desc: "Aiutaci a crescere lasciando una recensione. Ci vorranno solo 60 secondi.",
    start: "Inizia",
    step_write_title: "Scrivi la tua recensione",
    step_write_desc: "Scrivi una sola volta, la pubblicherai su tutte le piattaforme scelte.",
    placeholder: "Racconta com'è andata la tua esperienza…",
    min_chars: "Minimo 20 caratteri",
    next: "Avanti",
    back: "Indietro",
    step_share_title: "Pubblica ovunque",
    step_share_desc: "Tocca una piattaforma. Il testo verrà copiato automaticamente: incollalo e pubblicalo.",
    copy_and_open: "Copia e apri",
    copied: "Testo copiato! Incollalo nella recensione.",
    finish_title: "Grazie di cuore!",
    finish_desc: "Il tuo feedback fa una differenza enorme per noi.",
    done: "Ho finito",
    no_platforms: "Questo tour non ha ancora piattaforme configurate.",
    tour_not_found: "Tour non trovato",
    published_ok: "Pubblicato",
    private_title: "Grazie per il tuo feedback",
    private_desc: "Vorremmo migliorare. Il tuo commento resterà privato e non verrà pubblicato online.",
    private_email: "Email (opzionale)",
    private_name: "Nome (opzionale)",
    private_submit: "Invia feedback privato",
    private_thanks: "Grazie, il tuo feedback è stato inviato.",
    private_100: "100% privato",
    your_review: "La tua recensione",

    // Categories / multi-business
    category_tour: "Tour",
    category_restaurant: "Ristorante",
    category_hotel: "Hotel",
    category_service: "Servizio",
    restaurants_title: "I tuoi ristoranti",
    restaurants_subtitle: "Gestisci i ristoranti e i link delle piattaforme di recensione.",
    hotels_title: "I tuoi hotel",
    hotels_subtitle: "Gestisci gli hotel e i link delle piattaforme di recensione.",
    services_title: "I tuoi servizi",
    services_subtitle: "Gestisci i servizi e i link delle piattaforme di recensione.",
    new_restaurant_btn: "Aggiungi Ristorante",
    new_hotel_btn: "Aggiungi Hotel",
    new_service_btn: "Aggiungi Servizio",
    new_restaurant_title: "Nuovo Ristorante",
    new_hotel_title: "Nuovo Hotel",
    new_service_title: "Nuovo Servizio",
    edit_restaurant_title: "Modifica Ristorante",
    edit_hotel_title: "Modifica Hotel",
    edit_service_title: "Modifica Servizio",
    restaurant_name: "Nome del ristorante",
    hotel_name: "Nome dell'hotel",
    service_name: "Nome del servizio",
    restaurant_name_ph: "es. Trattoria da Mario",
    hotel_name_ph: "es. Hotel Bellavista",
    service_name_ph: "es. Studio dentistico Rossi",
    no_restaurants: "Nessun ristorante",
    no_hotels: "Nessun hotel",
    no_services: "Nessun servizio",
    no_restaurants_desc: "Crea il tuo primo ristorante e ottieni un link unico per raccogliere recensioni.",
    no_hotels_desc: "Crea il tuo primo hotel e ottieni un link unico per raccogliere recensioni.",
    no_services_desc: "Crea il tuo primo servizio e ottieni un link unico per raccogliere recensioni.",

    // QR code
    qr_code_btn: "QR Code",
    qr_dialog_title: "QR Code",
    qr_dialog_desc: "Stampalo o mostralo al cliente per raccogliere recensioni.",
    qr_download_btn: "Scarica PNG",
    qr_copy_link: "Copia link",

    // Auto-share sequential flow
    auto_share_title: "Pubblica la tua recensione",
    auto_share_desc: "Copiamo il testo e apriamo le piattaforme una alla volta. Basta incollare e cliccare Pubblica su ognuna.",
    auto_share_progress: "Piattaforma {current} di {total}",
    auto_share_open_now: "Apri {platform} e pubblica",
    auto_share_next: "Vai alla prossima",
    auto_share_finish: "Fatto, ho finito",
    auto_share_pasted_note: "Testo copiato negli appunti — incollalo nella pagina che si aprirà.",
    auto_share_start: "Inizia pubblicazione",
    auto_share_reopen: "Riapri {platform}",
    auto_share_prev: "◀ Precedente",
    auto_share_jump: "Vai a {platform}",
    finish_confirm_title: "Hai pubblicato su tutte le piattaforme?",
    finish_confirm_desc: "Le piattaforme non spuntate non riceveranno la tua recensione. Puoi tornare indietro se vuoi finire.",
    finish_confirm_yes: "Sì, ho finito",
    finish_confirm_back: "No, torno indietro",
    platform_visited: "Pubblicata",
    platform_not_visited: "Non ancora pubblicata",
    auto_share_skip: "Salta questa piattaforma",
    auto_share_login_warning: "⚠️ Se la pagina chiede di fare login e si blocca, usa il pulsante \"Salta\" qui sotto per passare alla prossima.",
    auto_share_google_tip: "💡 Google è la piattaforma più facile — probabilmente sei già loggato con il tuo account!",
  },
  en: {
    platform_done: "Review published",
    platform_tap_to_publish: "Tap to paste and publish",
    platforms_list_title: "Publish your review",
    platforms_list_desc: "Tap a platform: the text is copied, paste it and publish. Then come back here for the next one.",
    platforms_list_locked: "Pick the stars and write at least 20 characters to unlock the platforms.",
    platforms_progress: "{done} of {total} platforms completed",
    finish_now_btn: "I'm done",
    platform_confirm_title: "Did you publish on {platform}?",
    platform_confirm_desc: "Confirm the platform received your review so we can mark it as completed.",
    platform_confirm_yes: "Yes, published",
    platform_confirm_no: "Not yet",
    nav_login: "Log in",
    nav_signup: "Start free",
    nav_dashboard: "Dashboard",
    hero_badge: "For Tour Operators, Hotels, Restaurants & Services",
    hero_title_1: "One review,",
    hero_title_2: "every platform.",
    hero_desc: "Generate a single link for Tour Operators, Hotels, Restaurants and Services. Your customer writes one review and we help publish it to TripAdvisor, Google, Trustpilot and Facebook.",
    hero_cta: "Try free for 1 day",
    hero_trial_note: "1-day free trial",
    feat_unique_link: "Unique link per tour",
    feat_5_lang: "5 languages built-in",
    feat_analytics: "Real-time analytics",
    hero_card_today: "+3 reviews today",
    hero_card_completion: "completion rate",
    for_whom_kicker: "Who it's for",
    for_whom_title: "Built for anyone whose reputation lives online",
    for_whom_tour: "Tour Operators",
    for_whom_tour_desc: "Excursions, experiences, guides",
    for_whom_hotel: "Hotels & B&Bs",
    for_whom_hotel_desc: "Any size of hospitality business",
    for_whom_rest: "Restaurants",
    for_whom_rest_desc: "Venues, pizzerias, trattorias",
    for_whom_serv: "Services",
    for_whom_serv_desc: "Freelancers and local businesses",
    pricing_kicker: "Plans & Pricing",
    pricing_title: "Choose by number of platforms",
    pricing_subtitle: "Try free for 1 day. Change plan or cancel anytime.",
    cycle_monthly: "Monthly",
    cycle_semiannual: "6 months",
    cycle_annual: "Annual",
    plan_popular: "Popular",
    plan_starter: "Starter",
    plan_starter_desc: "Start collecting reviews",
    plan_growth: "Growth",
    plan_growth_desc: "The most popular choice",
    plan_pro: "Pro",
    plan_pro_desc: "Cover all major platforms",
    plan_business: "Business",
    plan_business_desc: "Multi-channel + priority support",
    per_month: "/mo",
    billed_monthly: "Billed monthly",
    billed_every_months: "every {n} months",
    billed_annually: "billed annually",
    plan_feat_platforms: "Up to {n} platforms",
    plan_feat_tours: "Unlimited tours / locations",
    plan_feat_multilang: "Multilingual customer page (5 languages)",
    plan_feat_smart: "Smart Filter private feedback",
    plan_feat_analytics: "Analytics dashboard",
    plan_feat_priority: "Priority support",
    plan_feat_credits: "{n} credits per month",
    plan_feat_photos: "Photos on reviews (max 3)",
    plan_cta_start: "Start 1-day free trial",
    plan_cta_dashboard: "Go to dashboard",
    pricing_footer: "Prices in USD. VAT excluded where applicable. Cancel anytime.",
    credits_title: "Available credits",
    credits_used_of: "{used} / {total} credits used",
    credits_reset: "Renews on {date}",
    credits_no_sub: "Free plan — subscribe for more credits",
    credits_upgrade: "See plans",
    how_credits_title: "How credits work",
    how_credits_desc: "Credits are consumed when a review is completed, based on delivery channel and number of platforms configured on the tour.",
    credit_cost_email: "Link via email / WhatsApp / SMS",
    credit_cost_qr: "Link via QR Code",
    credit_cost_photos: "Review with attached photos",
    credit_per_platform: "{n} credits / platform",
    credit_formula: "Total cost = cost × number of platforms configured on the tour",
    credits_exhausted_title: "Credits exhausted",
    credits_exhausted_desc: "This tour operator has used all this month's credits. Please come back later!",
    photos_title: "Add photos (optional)",
    photos_desc: "Max 3 photos. They will be shown along with your text when publishing.",
    photos_add: "Upload photo",
    photos_remove: "Remove",
    photos_uploading: "Uploading…",
    photos_max_reached: "Max 3 photos",
    photos_download_note: "Before publishing, save the photos to your phone to upload them on each platform.",
    footer_line: "One review, every platform.",

    auth_login_title: "Welcome back",
    auth_login_sub: "Sign in to your dashboard.",
    auth_register_title: "Create your account",
    auth_register_sub: "Start collecting reviews everywhere. 1-day free trial.",
    field_email: "Email",
    field_password: "Password",
    field_password_hint: "Password (min 6 characters)",
    field_business: "Business name",
    field_business_ph: "Your tour operator / hotel / restaurant",
    login_submit: "Log in",
    login_submitting: "Signing in…",
    register_submit: "Create account",
    register_submitting: "Creating…",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    signup_link: "Sign up",
    login_link: "Log in",
    auth_side_title: "Every customer, one review everywhere.",
    auth_side_sub: "Boost your business's online reputation.",
    toast_welcome_back: "Welcome back!",
    toast_welcome: "Welcome!",

    sidebar_dashboard: "Dashboard",
    sidebar_tours: "Tours",
    sidebar_restaurants: "Restaurants",
    sidebar_hotels: "Hotels",
    sidebar_services: "Services",
    sidebar_logout: "Log out",
    sidebar_connected_as: "Signed in as",
    dashboard_hi: "Hi",
    dashboard_title: "Dashboard",
    new_tour_btn: "Connect Platforms",
    kpi_tours: "Active tours",
    kpi_clicks: "Link opens",
    kpi_completions: "Completed",
    kpi_conversion: "Conversion rate",
    chart_platforms_title: "Clicks by platform",
    chart_platforms_sub: "Aggregated across all tours",
    your_tours: "Your tours",
    view_all: "View all",
    loading: "Loading…",
    no_tours_yet: "No tours yet.",
    create_first: "Create the first",
    events_opens: "opens",
    events_completed: "completed",

    tours_title: "Your tours",
    tours_subtitle: "Manage your tours and review-platform links.",
    search_ph: "Search…",
    no_tours: "No tours yet",
    no_tours_desc: "Create your first tour and get a unique link to send to your customers.",
    create_tour: "Create tour",
    n_platforms: "{n} platforms",
    no_description: "No description",
    copy_link_btn: "Copy link",
    toast_link_copied: "Link copied to clipboard",
    toast_link_customer_copied: "Link copied! Send it to your customer.",
    del_confirm_title: "Delete \"{name}\"?",
    del_confirm_desc: "This action is permanent. Statistics will be removed as well.",
    cancel: "Cancel",
    delete: "Delete",
    toast_tour_deleted: "Tour deleted",

    back_to_tours: "Back to tours",
    new_tour_title: "Connect Platforms",
    edit_tour_title: "Edit tour",
    copy_customer_link: "Copy customer link",
    tour_name: "Tour name",
    tour_name_ph: "e.g. Amalfi Sunset Excursion",
    tour_description: "Description (optional)",
    tour_description_ph: "Short description visible to the customer…",
    platforms_title: "Review platform links",
    platforms_desc: "Paste the write-review URL specific to this tour on each platform. Leave empty to hide it from the customer.",
    smart_filter_title: "Smart Filter",
    smart_filter_desc: "If the customer leaves fewer stars than the threshold, they are redirected to a private feedback form instead of being asked to post publicly.",
    smart_filter_label: "Minimum stars for public publishing",
    smart_filter_option: "{n}★ and up",
    smart_filter_hint_all: "All reviews are sent to public platforms.",
    smart_filter_hint: "With less than {n} stars the customer will only see the private form.",
    feedback_title: "Private feedback received",
    feedback_empty: "No private feedback yet. When a customer leaves a low rating, their message will appear here.",
    how_it_works: "How it works",
    how_1: "Save the tour and get its unique link",
    how_2: "Send it to the customer via WhatsApp, email or SMS",
    how_3: "The customer writes the review once",
    how_4: "The app copies the text and opens the platforms in sequence",
    save_tour: "Save tour",
    saving: "Saving…",
    toast_tour_created: "Tour created!",
    toast_saved: "Saved",
    name_required: "Tour name is required",

    welcome_hi: "Hi there!",
    welcome_sub: "Thanks for choosing",
    welcome_desc: "Help us grow by leaving a review. It only takes 60 seconds.",
    start: "Start",
    step_write_title: "Write your review",
    step_write_desc: "Write it once. You'll publish it on every platform you like.",
    placeholder: "Tell us how your experience went…",
    min_chars: "Minimum 20 characters",
    next: "Next",
    back: "Back",
    step_share_title: "Publish everywhere",
    step_share_desc: "Tap a platform. Your text is copied automatically — just paste and publish.",
    copy_and_open: "Copy & open",
    copied: "Text copied! Paste it in the review.",
    finish_title: "Thank you so much!",
    finish_desc: "Your feedback makes a huge difference for us.",
    done: "I'm done",
    no_platforms: "This tour has no review platforms configured yet.",
    tour_not_found: "Tour not found",
    published_ok: "Published",
    private_title: "Thanks for your feedback",
    private_desc: "We'd love to improve. Your message stays private — it won't be posted online.",
    private_email: "Email (optional)",
    private_name: "Name (optional)",
    private_submit: "Send private feedback",
    private_thanks: "Thanks, your feedback has been sent.",
    private_100: "100% private",
    your_review: "Your review",

    // Categories / multi-business
    category_tour: "Tour",
    category_restaurant: "Restaurant",
    category_hotel: "Hotel",
    category_service: "Service",
    restaurants_title: "Your restaurants",
    restaurants_subtitle: "Manage your restaurants and review-platform links.",
    hotels_title: "Your hotels",
    hotels_subtitle: "Manage your hotels and review-platform links.",
    services_title: "Your services",
    services_subtitle: "Manage your services and review-platform links.",
    new_restaurant_btn: "Add Restaurant",
    new_hotel_btn: "Add Hotel",
    new_service_btn: "Add Service",
    new_restaurant_title: "New Restaurant",
    new_hotel_title: "New Hotel",
    new_service_title: "New Service",
    edit_restaurant_title: "Edit Restaurant",
    edit_hotel_title: "Edit Hotel",
    edit_service_title: "Edit Service",
    restaurant_name: "Restaurant name",
    hotel_name: "Hotel name",
    service_name: "Service name",
    restaurant_name_ph: "e.g. Mario's Trattoria",
    hotel_name_ph: "e.g. Hotel Bellavista",
    service_name_ph: "e.g. Rossi Dental Clinic",
    no_restaurants: "No restaurants yet",
    no_hotels: "No hotels yet",
    no_services: "No services yet",
    no_restaurants_desc: "Create your first restaurant and get a unique link to collect reviews.",
    no_hotels_desc: "Create your first hotel and get a unique link to collect reviews.",
    no_services_desc: "Create your first service and get a unique link to collect reviews.",

    // QR code
    qr_code_btn: "QR Code",
    qr_dialog_title: "QR Code",
    qr_dialog_desc: "Print it or show it to the customer to collect reviews.",
    qr_download_btn: "Download PNG",
    qr_copy_link: "Copy link",

    // Auto-share sequential flow
    auto_share_title: "Publish your review",
    auto_share_desc: "We copy the text and open the platforms one by one. Just paste and click Publish on each.",
    auto_share_progress: "Platform {current} of {total}",
    auto_share_open_now: "Open {platform} & publish",
    auto_share_next: "Go to next",
    auto_share_finish: "Done, I've finished",
    auto_share_pasted_note: "Text copied to clipboard — paste it into the page that opens.",
    auto_share_start: "Start publishing",
    auto_share_reopen: "Reopen {platform}",
    auto_share_prev: "◀ Previous",
    auto_share_jump: "Go to {platform}",
    finish_confirm_title: "Did you publish on every platform?",
    finish_confirm_desc: "Unchecked platforms won't receive your review. You can go back if you want to finish.",
    finish_confirm_yes: "Yes, I'm done",
    finish_confirm_back: "No, go back",
    platform_visited: "Published",
    platform_not_visited: "Not yet published",
    auto_share_skip: "Skip this platform",
    auto_share_login_warning: "⚠️ If the page asks you to log in and gets stuck, tap \"Skip\" below to move on.",
    auto_share_google_tip: "💡 Google is the easiest — you're probably already logged into your Google account!",
  },
  es: {
    platform_done: "Reseña publicada",
    platform_tap_to_publish: "Toca para pegar y publicar",
    platforms_list_title: "Publica tu reseña",
    platforms_list_desc: "Toca una plataforma: el texto se copia, pégalo y publica. Luego vuelve aquí para la siguiente.",
    platforms_list_locked: "Elige las estrellas y escribe al menos 20 caracteres para desbloquear las plataformas.",
    platforms_progress: "{done} de {total} plataformas completadas",
    finish_now_btn: "He terminado",
    platform_confirm_title: "¿Has publicado en {platform}?",
    platform_confirm_desc: "Confirma que la plataforma recibió tu reseña para marcarla como completada.",
    platform_confirm_yes: "Sí, publicada",
    platform_confirm_no: "Todavía no",
    nav_login: "Iniciar sesión",
    nav_signup: "Empezar gratis",
    nav_dashboard: "Panel",
    hero_badge: "Para Tour Operadores, Hoteles, Restaurantes & Servicios",
    hero_title_1: "Una reseña,",
    hero_title_2: "todas las plataformas.",
    hero_desc: "Genera un único enlace para Tour Operadores, Hoteles, Restaurantes y Servicios. Tu cliente escribe una sola reseña y la publicamos en TripAdvisor, Google, Trustpilot y Facebook.",
    hero_cta: "Prueba gratis 1 día",
    hero_trial_note: "1 día de prueba gratis",
    feat_unique_link: "Enlace único por tour",
    feat_5_lang: "5 idiomas integrados",
    feat_analytics: "Analíticas en tiempo real",
    hero_card_today: "+3 reseñas hoy",
    hero_card_completion: "tasa de finalización",
    for_whom_kicker: "Para quién",
    for_whom_title: "Pensado para quien vive de su reputación online",
    for_whom_tour: "Tour Operadores",
    for_whom_tour_desc: "Excursiones, experiencias, guías",
    for_whom_hotel: "Hoteles & B&B",
    for_whom_hotel_desc: "Alojamientos de cualquier tamaño",
    for_whom_rest: "Restaurantes",
    for_whom_rest_desc: "Locales, pizzerías, trattorías",
    for_whom_serv: "Servicios",
    for_whom_serv_desc: "Profesionales y negocios locales",
    pricing_kicker: "Planes & Precios",
    pricing_title: "Elige según las plataformas",
    pricing_subtitle: "Prueba 1 día gratis. Cambia de plan o cancela cuando quieras.",
    cycle_monthly: "Mensual",
    cycle_semiannual: "Semestral",
    cycle_annual: "Anual",
    plan_popular: "Popular",
    plan_starter: "Starter",
    plan_starter_desc: "Empieza a recibir reseñas",
    plan_growth: "Growth",
    plan_growth_desc: "La opción más elegida",
    plan_pro: "Pro",
    plan_pro_desc: "Cubre todas las plataformas principales",
    plan_business: "Business",
    plan_business_desc: "Multi-canal + soporte prioritario",
    per_month: "/mes",
    billed_monthly: "Facturación mensual",
    billed_every_months: "cada {n} meses",
    billed_annually: "facturado anualmente",
    plan_feat_platforms: "Hasta {n} plataformas",
    plan_feat_tours: "Tours / locales ilimitados",
    plan_feat_multilang: "Página cliente multilingüe (5 idiomas)",
    plan_feat_smart: "Smart Filter comentarios privados",
    plan_feat_analytics: "Panel de analíticas",
    plan_feat_priority: "Soporte prioritario",
    plan_cta_start: "Prueba gratis 1 día",
    plan_cta_dashboard: "Ir al panel",
    pricing_footer: "Precios en USD. IVA no incluido cuando aplique. Cancela cuando quieras.",
    footer_line: "Una reseña, todas las plataformas.",

    auth_login_title: "Bienvenido de nuevo",
    auth_login_sub: "Accede a tu panel.",
    auth_register_title: "Crea tu cuenta",
    auth_register_sub: "Empieza a recibir reseñas por todas partes. 1 día gratis.",
    field_email: "Email",
    field_password: "Contraseña",
    field_password_hint: "Contraseña (mín. 6 caracteres)",
    field_business: "Nombre del negocio",
    field_business_ph: "Tu tour operador / hotel / restaurante",
    login_submit: "Entrar",
    login_submitting: "Entrando…",
    register_submit: "Crear cuenta",
    register_submitting: "Creando…",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    signup_link: "Regístrate",
    login_link: "Iniciar sesión",
    auth_side_title: "Cada cliente, una reseña en todas partes.",
    auth_side_sub: "Impulsa la reputación online de tu negocio.",
    toast_welcome_back: "¡Bienvenido de nuevo!",
    toast_welcome: "¡Bienvenido!",

    sidebar_dashboard: "Panel",
    sidebar_tours: "Tours",
    sidebar_restaurants: "Restaurantes",
    sidebar_hotels: "Hoteles",
    sidebar_services: "Servicios",
    sidebar_logout: "Salir",
    sidebar_connected_as: "Conectado como",
    dashboard_hi: "Hola",
    dashboard_title: "Panel",
    new_tour_btn: "Conectar Plataformas",
    kpi_tours: "Tours activos",
    kpi_clicks: "Enlaces abiertos",
    kpi_completions: "Completados",
    kpi_conversion: "Tasa de conversión",
    chart_platforms_title: "Clics por plataforma",
    chart_platforms_sub: "Agregado de todos los tours",
    your_tours: "Tus tours",
    view_all: "Ver todos",
    loading: "Cargando…",
    no_tours_yet: "Aún no tienes tours.",
    create_first: "Crear el primero",
    events_opens: "aperturas",
    events_completed: "completados",

    tours_title: "Tus tours",
    tours_subtitle: "Gestiona los tours y los enlaces de las plataformas de reseña.",
    search_ph: "Buscar…",
    no_tours: "Sin tours",
    no_tours_desc: "Crea tu primer tour y consigue un enlace único para enviarlo a tus clientes.",
    create_tour: "Crear tour",
    n_platforms: "{n} plataformas",
    no_description: "Sin descripción",
    copy_link_btn: "Copiar enlace",
    toast_link_copied: "Enlace copiado al portapapeles",
    toast_link_customer_copied: "¡Enlace copiado! Envíalo a tu cliente.",
    del_confirm_title: "¿Eliminar \"{name}\"?",
    del_confirm_desc: "Esta acción es permanente. También se borrarán las estadísticas.",
    cancel: "Cancelar",
    delete: "Eliminar",
    toast_tour_deleted: "Tour eliminado",

    back_to_tours: "Volver a los tours",
    new_tour_title: "Conectar Plataformas",
    edit_tour_title: "Editar tour",
    copy_customer_link: "Copiar enlace cliente",
    tour_name: "Nombre del tour",
    tour_name_ph: "ej. Excursión Amalfi al atardecer",
    tour_description: "Descripción (opcional)",
    tour_description_ph: "Descripción breve visible al cliente…",
    platforms_title: "Enlaces a las plataformas de reseña",
    platforms_desc: "Pega la URL de escritura de reseña específica de este tour en cada plataforma. Déjala vacía para no mostrarla al cliente.",
    smart_filter_title: "Smart Filter",
    smart_filter_desc: "Si el cliente deja menos estrellas del umbral, se le redirige a un formulario privado en lugar de invitarlo a publicar online.",
    smart_filter_label: "Estrellas mínimas para publicar en público",
    smart_filter_option: "{n}★ o más",
    smart_filter_hint_all: "Todas las reseñas se dirigirán a las plataformas públicas.",
    smart_filter_hint: "Con menos de {n} estrellas el cliente solo verá el formulario privado.",
    feedback_title: "Comentarios privados recibidos",
    feedback_empty: "Aún no hay comentarios privados. Cuando un cliente deje una valoración baja, verás aquí su mensaje.",
    how_it_works: "Cómo funciona",
    how_1: "Guarda el tour y obtén su enlace único",
    how_2: "Envíalo al cliente por WhatsApp, email o SMS",
    how_3: "El cliente escribe la reseña una sola vez",
    how_4: "La app copia el texto y abre las plataformas en secuencia",
    save_tour: "Guardar tour",
    saving: "Guardando…",
    toast_tour_created: "¡Tour creado!",
    toast_saved: "Guardado",
    name_required: "El nombre del tour es obligatorio",

    welcome_hi: "¡Hola!",
    welcome_sub: "Gracias por elegir",
    welcome_desc: "Ayúdanos a crecer dejando una reseña. Solo tardarás 60 segundos.",
    start: "Empezar",
    step_write_title: "Escribe tu reseña",
    step_write_desc: "Escríbela una sola vez. La publicarás en todas las plataformas.",
    placeholder: "Cuéntanos cómo fue tu experiencia…",
    min_chars: "Mínimo 20 caracteres",
    next: "Siguiente",
    back: "Volver",
    step_share_title: "Publica en todas partes",
    step_share_desc: "Toca una plataforma. El texto se copia automáticamente: solo pega y publica.",
    copy_and_open: "Copiar y abrir",
    copied: "¡Texto copiado! Pégalo en la reseña.",
    finish_title: "¡Muchísimas gracias!",
    finish_desc: "Tu opinión marca una gran diferencia para nosotros.",
    done: "He terminado",
    no_platforms: "Este tour aún no tiene plataformas configuradas.",
    tour_not_found: "Tour no encontrado",
    published_ok: "Publicado",
    private_title: "Gracias por tu opinión",
    private_desc: "Queremos mejorar. Tu mensaje será privado y no se publicará en línea.",
    private_email: "Email (opcional)",
    private_name: "Nombre (opcional)",
    private_submit: "Enviar comentario privado",
    private_thanks: "Gracias, tu comentario se ha enviado.",
    private_100: "100% privado",
    your_review: "Tu reseña",

    category_tour: "Tour",
    category_restaurant: "Restaurante",
    category_hotel: "Hotel",
    category_service: "Servicio",
    restaurants_title: "Tus restaurantes",
    restaurants_subtitle: "Gestiona tus restaurantes y los enlaces de las plataformas de reseña.",
    hotels_title: "Tus hoteles",
    hotels_subtitle: "Gestiona tus hoteles y los enlaces de las plataformas de reseña.",
    services_title: "Tus servicios",
    services_subtitle: "Gestiona tus servicios y los enlaces de las plataformas de reseña.",
    new_restaurant_btn: "Añadir Restaurante",
    new_hotel_btn: "Añadir Hotel",
    new_service_btn: "Añadir Servicio",
    new_restaurant_title: "Nuevo Restaurante",
    new_hotel_title: "Nuevo Hotel",
    new_service_title: "Nuevo Servicio",
    edit_restaurant_title: "Editar Restaurante",
    edit_hotel_title: "Editar Hotel",
    edit_service_title: "Editar Servicio",
    restaurant_name: "Nombre del restaurante",
    hotel_name: "Nombre del hotel",
    service_name: "Nombre del servicio",
    restaurant_name_ph: "ej. Trattoria de Mario",
    hotel_name_ph: "ej. Hotel Bellavista",
    service_name_ph: "ej. Clínica Dental Rossi",
    no_restaurants: "Sin restaurantes",
    no_hotels: "Sin hoteles",
    no_services: "Sin servicios",
    no_restaurants_desc: "Crea tu primer restaurante y consigue un enlace único para recoger reseñas.",
    no_hotels_desc: "Crea tu primer hotel y consigue un enlace único para recoger reseñas.",
    no_services_desc: "Crea tu primer servicio y consigue un enlace único para recoger reseñas.",

    qr_code_btn: "Código QR",
    qr_dialog_title: "Código QR",
    qr_dialog_desc: "Imprímelo o muéstraselo al cliente para recoger reseñas.",
    qr_download_btn: "Descargar PNG",
    qr_copy_link: "Copiar enlace",

    auto_share_title: "Publica tu reseña",
    auto_share_desc: "Copiamos el texto y abrimos las plataformas una a una. Solo pega y haz clic en Publicar en cada una.",
    auto_share_progress: "Plataforma {current} de {total}",
    auto_share_open_now: "Abrir {platform} y publicar",
    auto_share_next: "Ir a la siguiente",
    auto_share_finish: "Listo, he terminado",
    auto_share_pasted_note: "Texto copiado al portapapeles — pégalo en la página que se abrirá.",
    auto_share_start: "Empezar publicación",
    auto_share_reopen: "Reabrir {platform}",
    auto_share_prev: "◀ Anterior",
    auto_share_jump: "Ir a {platform}",
    finish_confirm_title: "¿Publicaste en todas las plataformas?",
    finish_confirm_desc: "Las plataformas no marcadas no recibirán tu reseña. Puedes volver atrás si quieres terminar.",
    finish_confirm_yes: "Sí, he terminado",
    finish_confirm_back: "No, volver atrás",
    platform_visited: "Publicada",
    platform_not_visited: "Aún no publicada",
    auto_share_skip: "Saltar esta plataforma",
    auto_share_login_warning: "⚠️ Si la página pide iniciar sesión y se bloquea, pulsa \"Saltar\" para continuar.",
    auto_share_google_tip: "💡 Google es la más fácil — ¡probablemente ya estás conectado con tu cuenta Google!",
  },
  fr: {
    platform_done: "Avis publié",
    platform_tap_to_publish: "Touchez pour coller et publier",
    platforms_list_title: "Publiez votre avis",
    platforms_list_desc: "Touchez une plateforme : le texte est copié, collez-le et publiez. Puis revenez ici pour la suivante.",
    platforms_list_locked: "Choisissez les étoiles et écrivez au moins 20 caractères pour débloquer les plateformes.",
    platforms_progress: "{done} sur {total} plateformes terminées",
    finish_now_btn: "J'ai terminé",
    platform_confirm_title: "Avez-vous publié sur {platform} ?",
    platform_confirm_desc: "Confirmez que la plateforme a reçu votre avis pour la marquer comme terminée.",
    platform_confirm_yes: "Oui, publié",
    platform_confirm_no: "Pas encore",
    nav_login: "Se connecter",
    nav_signup: "Essai gratuit",
    nav_dashboard: "Tableau de bord",
    hero_badge: "Pour Tour-opérateurs, Hôtels, Restaurants & Services",
    hero_title_1: "Un seul avis,",
    hero_title_2: "toutes les plateformes.",
    hero_desc: "Génère un lien unique pour tour-opérateurs, hôtels, restaurants et services. Ton client écrit un seul avis et nous l'aidons à le publier sur TripAdvisor, Google, Trustpilot et Facebook.",
    hero_cta: "Essai gratuit 1 jour",
    hero_trial_note: "1 jour d'essai gratuit",
    feat_unique_link: "Lien unique par tour",
    feat_5_lang: "5 langues intégrées",
    feat_analytics: "Analytics en temps réel",
    hero_card_today: "+3 avis aujourd'hui",
    hero_card_completion: "taux de complétion",
    for_whom_kicker: "Pour qui",
    for_whom_title: "Conçu pour celles et ceux qui vivent de leur réputation en ligne",
    for_whom_tour: "Tour-opérateurs",
    for_whom_tour_desc: "Excursions, expériences, guides",
    for_whom_hotel: "Hôtels & B&B",
    for_whom_hotel_desc: "Hébergements de toutes tailles",
    for_whom_rest: "Restaurants",
    for_whom_rest_desc: "Restos, pizzerias, trattorias",
    for_whom_serv: "Services",
    for_whom_serv_desc: "Indépendants et commerces locaux",
    pricing_kicker: "Plans & Tarifs",
    pricing_title: "Choisissez selon les plateformes",
    pricing_subtitle: "Essai gratuit 1 jour. Changez de plan ou annulez quand vous voulez.",
    cycle_monthly: "Mensuel",
    cycle_semiannual: "Semestriel",
    cycle_annual: "Annuel",
    plan_popular: "Populaire",
    plan_starter: "Starter",
    plan_starter_desc: "Commencer à récolter des avis",
    plan_growth: "Growth",
    plan_growth_desc: "Le plus choisi par les pros",
    plan_pro: "Pro",
    plan_pro_desc: "Couvre toutes les grandes plateformes",
    plan_business: "Business",
    plan_business_desc: "Multi-canal + support prioritaire",
    per_month: "/mois",
    billed_monthly: "Facturation mensuelle",
    billed_every_months: "tous les {n} mois",
    billed_annually: "facturé annuellement",
    plan_feat_platforms: "Jusqu'à {n} plateformes",
    plan_feat_tours: "Tours / points de vente illimités",
    plan_feat_multilang: "Page client multilingue (5 langues)",
    plan_feat_smart: "Smart Filter retour privé",
    plan_feat_analytics: "Tableau de bord analytics",
    plan_feat_priority: "Support prioritaire",
    plan_cta_start: "Essai gratuit 1 jour",
    plan_cta_dashboard: "Aller au tableau de bord",
    pricing_footer: "Prix en USD. TVA non incluse le cas échéant. Annulation à tout moment.",
    footer_line: "Un avis, toutes les plateformes.",

    auth_login_title: "Content de te revoir",
    auth_login_sub: "Connecte-toi à ton tableau de bord.",
    auth_register_title: "Crée ton compte",
    auth_register_sub: "Commence à récolter des avis partout. 1 jour d'essai gratuit.",
    field_email: "Email",
    field_password: "Mot de passe",
    field_password_hint: "Mot de passe (min. 6 caractères)",
    field_business: "Nom de l'entreprise",
    field_business_ph: "Ton tour-opérateur / hôtel / restaurant",
    login_submit: "Se connecter",
    login_submitting: "Connexion…",
    register_submit: "Créer un compte",
    register_submitting: "Création…",
    no_account: "Pas encore de compte ?",
    have_account: "Déjà un compte ?",
    signup_link: "S'inscrire",
    login_link: "Se connecter",
    auth_side_title: "Chaque client, un avis partout.",
    auth_side_sub: "Booste la réputation en ligne de ton activité.",
    toast_welcome_back: "Bon retour !",
    toast_welcome: "Bienvenue !",

    sidebar_dashboard: "Tableau de bord",
    sidebar_tours: "Tours",
    sidebar_restaurants: "Restaurants",
    sidebar_hotels: "Hôtels",
    sidebar_services: "Services",
    sidebar_logout: "Se déconnecter",
    sidebar_connected_as: "Connecté en tant que",
    dashboard_hi: "Salut",
    dashboard_title: "Tableau de bord",
    new_tour_btn: "Connecter les Plateformes",
    kpi_tours: "Tours actifs",
    kpi_clicks: "Liens ouverts",
    kpi_completions: "Complétés",
    kpi_conversion: "Taux de conversion",
    chart_platforms_title: "Clics par plateforme",
    chart_platforms_sub: "Cumulé sur tous les tours",
    your_tours: "Tes tours",
    view_all: "Tout voir",
    loading: "Chargement…",
    no_tours_yet: "Aucun tour pour le moment.",
    create_first: "Créer le premier",
    events_opens: "ouvertures",
    events_completed: "complétés",

    tours_title: "Tes tours",
    tours_subtitle: "Gère les tours et les liens vers les plateformes d'avis.",
    search_ph: "Rechercher…",
    no_tours: "Aucun tour",
    no_tours_desc: "Crée ton premier tour et obtiens un lien unique à envoyer à tes clients.",
    create_tour: "Créer un tour",
    n_platforms: "{n} plateformes",
    no_description: "Aucune description",
    copy_link_btn: "Copier le lien",
    toast_link_copied: "Lien copié dans le presse-papiers",
    toast_link_customer_copied: "Lien copié ! Envoie-le à ton client.",
    del_confirm_title: "Supprimer « {name} » ?",
    del_confirm_desc: "Cette action est définitive. Les statistiques seront également supprimées.",
    cancel: "Annuler",
    delete: "Supprimer",
    toast_tour_deleted: "Tour supprimé",

    back_to_tours: "Retour aux tours",
    new_tour_title: "Connecter les Plateformes",
    edit_tour_title: "Modifier le tour",
    copy_customer_link: "Copier le lien client",
    tour_name: "Nom du tour",
    tour_name_ph: "ex. Excursion Amalfi au coucher du soleil",
    tour_description: "Description (facultative)",
    tour_description_ph: "Brève description visible par le client…",
    platforms_title: "Liens vers les plateformes d'avis",
    platforms_desc: "Colle l'URL d'écriture d'avis spécifique à ce tour sur chaque plateforme. Laisse vide pour ne pas la montrer au client.",
    smart_filter_title: "Smart Filter",
    smart_filter_desc: "Si le client laisse moins d'étoiles que le seuil, il est redirigé vers un formulaire privé au lieu d'être invité à publier publiquement.",
    smart_filter_label: "Étoiles minimales pour publier en public",
    smart_filter_option: "{n}★ et plus",
    smart_filter_hint_all: "Tous les avis seront dirigés vers les plateformes publiques.",
    smart_filter_hint: "Avec moins de {n} étoiles, le client ne verra que le formulaire privé.",
    feedback_title: "Avis privés reçus",
    feedback_empty: "Aucun avis privé pour l'instant. Lorsqu'un client laissera une note basse, tu verras son message ici.",
    how_it_works: "Comment ça marche",
    how_1: "Enregistre le tour et obtiens son lien unique",
    how_2: "Envoie-le au client via WhatsApp, email ou SMS",
    how_3: "Le client écrit l'avis une seule fois",
    how_4: "L'app copie le texte et ouvre les plateformes en séquence",
    save_tour: "Enregistrer le tour",
    saving: "Enregistrement…",
    toast_tour_created: "Tour créé !",
    toast_saved: "Enregistré",
    name_required: "Le nom du tour est obligatoire",

    welcome_hi: "Bonjour !",
    welcome_sub: "Merci d'avoir choisi",
    welcome_desc: "Aidez-nous à grandir en laissant un avis. Cela ne prend que 60 secondes.",
    start: "Commencer",
    step_write_title: "Rédigez votre avis",
    step_write_desc: "Écrivez-le une seule fois. Vous le publierez sur toutes les plateformes.",
    placeholder: "Racontez-nous votre expérience…",
    min_chars: "Minimum 20 caractères",
    next: "Suivant",
    back: "Retour",
    step_share_title: "Publiez partout",
    step_share_desc: "Touchez une plateforme. Votre texte est copié automatiquement — collez et publiez.",
    copy_and_open: "Copier et ouvrir",
    copied: "Texte copié ! Collez-le dans l'avis.",
    finish_title: "Merci infiniment !",
    finish_desc: "Votre avis fait une énorme différence pour nous.",
    done: "J'ai terminé",
    no_platforms: "Ce tour n'a pas encore de plateformes configurées.",
    tour_not_found: "Tour introuvable",
    published_ok: "Publié",
    private_title: "Merci pour votre retour",
    private_desc: "Nous voulons nous améliorer. Votre message restera privé et ne sera pas publié en ligne.",
    private_email: "Email (facultatif)",
    private_name: "Nom (facultatif)",
    private_submit: "Envoyer un avis privé",
    private_thanks: "Merci, votre avis a bien été envoyé.",
    private_100: "100% privé",
    your_review: "Votre avis",

    category_tour: "Tour",
    category_restaurant: "Restaurant",
    category_hotel: "Hôtel",
    category_service: "Service",
    restaurants_title: "Tes restaurants",
    restaurants_subtitle: "Gère tes restaurants et les liens vers les plateformes d'avis.",
    hotels_title: "Tes hôtels",
    hotels_subtitle: "Gère tes hôtels et les liens vers les plateformes d'avis.",
    services_title: "Tes services",
    services_subtitle: "Gère tes services et les liens vers les plateformes d'avis.",
    new_restaurant_btn: "Ajouter Restaurant",
    new_hotel_btn: "Ajouter Hôtel",
    new_service_btn: "Ajouter Service",
    new_restaurant_title: "Nouveau Restaurant",
    new_hotel_title: "Nouvel Hôtel",
    new_service_title: "Nouveau Service",
    edit_restaurant_title: "Modifier le Restaurant",
    edit_hotel_title: "Modifier l'Hôtel",
    edit_service_title: "Modifier le Service",
    restaurant_name: "Nom du restaurant",
    hotel_name: "Nom de l'hôtel",
    service_name: "Nom du service",
    restaurant_name_ph: "ex. Trattoria de Mario",
    hotel_name_ph: "ex. Hôtel Bellavista",
    service_name_ph: "ex. Cabinet dentaire Rossi",
    no_restaurants: "Aucun restaurant",
    no_hotels: "Aucun hôtel",
    no_services: "Aucun service",
    no_restaurants_desc: "Crée ton premier restaurant et obtiens un lien unique pour récolter des avis.",
    no_hotels_desc: "Crée ton premier hôtel et obtiens un lien unique pour récolter des avis.",
    no_services_desc: "Crée ton premier service et obtiens un lien unique pour récolter des avis.",

    qr_code_btn: "QR Code",
    qr_dialog_title: "QR Code",
    qr_dialog_desc: "Imprime-le ou montre-le au client pour récolter des avis.",
    qr_download_btn: "Télécharger PNG",
    qr_copy_link: "Copier le lien",

    auto_share_title: "Publiez votre avis",
    auto_share_desc: "Nous copions le texte et ouvrons les plateformes une par une. Collez et cliquez sur Publier sur chacune.",
    auto_share_progress: "Plateforme {current} sur {total}",
    auto_share_open_now: "Ouvrir {platform} et publier",
    auto_share_next: "Aller à la suivante",
    auto_share_finish: "C'est terminé",
    auto_share_pasted_note: "Texte copié dans le presse-papiers — collez-le sur la page qui va s'ouvrir.",
    auto_share_start: "Commencer la publication",
    auto_share_reopen: "Rouvrir {platform}",
    auto_share_prev: "◀ Précédent",
    auto_share_jump: "Aller à {platform}",
    finish_confirm_title: "Avez-vous publié sur toutes les plateformes ?",
    finish_confirm_desc: "Les plateformes non cochées ne recevront pas votre avis. Vous pouvez revenir en arrière si vous voulez finir.",
    finish_confirm_yes: "Oui, j'ai terminé",
    finish_confirm_back: "Non, revenir",
    platform_visited: "Publié",
    platform_not_visited: "Pas encore publié",
    auto_share_skip: "Passer cette plateforme",
    auto_share_login_warning: "⚠️ Si la page demande une connexion et se bloque, cliquez sur \"Passer\" pour continuer.",
    auto_share_google_tip: "💡 Google est le plus facile — vous êtes sûrement déjà connecté avec votre compte Google !",
  },
  de: {
    platform_done: "Bewertung veröffentlicht",
    platform_tap_to_publish: "Tippen zum Einfügen und Veröffentlichen",
    platforms_list_title: "Bewertung veröffentlichen",
    platforms_list_desc: "Tippe auf eine Plattform: Der Text wird kopiert, füge ihn ein und veröffentliche. Dann komm hierher zurück für die nächste.",
    platforms_list_locked: "Wähle die Sterne und schreibe mindestens 20 Zeichen, um die Plattformen freizuschalten.",
    platforms_progress: "{done} von {total} Plattformen erledigt",
    finish_now_btn: "Ich bin fertig",
    platform_confirm_title: "Hast du auf {platform} veröffentlicht?",
    platform_confirm_desc: "Bestätige, dass die Plattform deine Bewertung erhalten hat, damit wir sie als erledigt markieren.",
    platform_confirm_yes: "Ja, veröffentlicht",
    platform_confirm_no: "Noch nicht",
    nav_login: "Anmelden",
    nav_signup: "Kostenlos starten",
    nav_dashboard: "Dashboard",
    hero_badge: "Für Tour-Operator, Hotels, Restaurants & Services",
    hero_title_1: "Eine Bewertung,",
    hero_title_2: "alle Plattformen.",
    hero_desc: "Erstelle einen einzigen Link für Tour-Operator, Hotels, Restaurants und Services. Dein Kunde schreibt eine Bewertung und wir helfen sie auf TripAdvisor, Google, Trustpilot und Facebook zu veröffentlichen.",
    hero_cta: "1 Tag kostenlos testen",
    hero_trial_note: "1 Tag kostenlos testen",
    feat_unique_link: "Einzigartiger Link pro Tour",
    feat_5_lang: "5 Sprachen integriert",
    feat_analytics: "Echtzeit-Analytics",
    hero_card_today: "+3 Bewertungen heute",
    hero_card_completion: "Abschlussquote",
    for_whom_kicker: "Für wen",
    for_whom_title: "Für alle, deren Ruf online lebt",
    for_whom_tour: "Tour-Operator",
    for_whom_tour_desc: "Ausflüge, Erlebnisse, Guides",
    for_whom_hotel: "Hotels & B&B",
    for_whom_hotel_desc: "Unterkünfte jeder Größe",
    for_whom_rest: "Restaurants",
    for_whom_rest_desc: "Lokale, Pizzerien, Trattorien",
    for_whom_serv: "Services",
    for_whom_serv_desc: "Selbständige und lokale Betriebe",
    pricing_kicker: "Pläne & Preise",
    pricing_title: "Wähle nach Plattformen",
    pricing_subtitle: "1 Tag kostenlos testen. Plan wechseln oder jederzeit kündigen.",
    cycle_monthly: "Monatlich",
    cycle_semiannual: "Halbjährlich",
    cycle_annual: "Jährlich",
    plan_popular: "Beliebt",
    plan_starter: "Starter",
    plan_starter_desc: "Erste Bewertungen sammeln",
    plan_growth: "Growth",
    plan_growth_desc: "Am häufigsten gewählt",
    plan_pro: "Pro",
    plan_pro_desc: "Alle wichtigen Plattformen abdecken",
    plan_business: "Business",
    plan_business_desc: "Multi-Channel + Priority-Support",
    per_month: "/Monat",
    billed_monthly: "Monatliche Abrechnung",
    billed_every_months: "alle {n} Monate",
    billed_annually: "jährlich abgerechnet",
    plan_feat_platforms: "Bis zu {n} Plattformen",
    plan_feat_tours: "Unbegrenzte Touren / Standorte",
    plan_feat_multilang: "Mehrsprachige Kundenseite (5 Sprachen)",
    plan_feat_smart: "Smart Filter privates Feedback",
    plan_feat_analytics: "Analytics Dashboard",
    plan_feat_priority: "Priority Support",
    plan_cta_start: "1 Tag kostenlos testen",
    plan_cta_dashboard: "Zum Dashboard",
    pricing_footer: "Preise in USD. MwSt. ggf. exkl. Jederzeit kündbar.",
    footer_line: "Eine Bewertung, alle Plattformen.",

    auth_login_title: "Willkommen zurück",
    auth_login_sub: "Melde dich am Dashboard an.",
    auth_register_title: "Konto erstellen",
    auth_register_sub: "Überall Bewertungen sammeln. 1 Tag kostenlos testen.",
    field_email: "E-Mail",
    field_password: "Passwort",
    field_password_hint: "Passwort (mind. 6 Zeichen)",
    field_business: "Firmenname",
    field_business_ph: "Dein Tour-Operator / Hotel / Restaurant",
    login_submit: "Anmelden",
    login_submitting: "Anmelden…",
    register_submit: "Konto erstellen",
    register_submitting: "Erstelle…",
    no_account: "Noch kein Konto?",
    have_account: "Schon ein Konto?",
    signup_link: "Registrieren",
    login_link: "Anmelden",
    auth_side_title: "Jeder Kunde, eine Bewertung überall.",
    auth_side_sub: "Stärke die Online-Reputation deines Betriebs.",
    toast_welcome_back: "Willkommen zurück!",
    toast_welcome: "Willkommen!",

    sidebar_dashboard: "Dashboard",
    sidebar_tours: "Touren",
    sidebar_restaurants: "Restaurants",
    sidebar_hotels: "Hotels",
    sidebar_services: "Dienstleistungen",
    sidebar_logout: "Abmelden",
    sidebar_connected_as: "Angemeldet als",
    dashboard_hi: "Hallo",
    dashboard_title: "Dashboard",
    new_tour_btn: "Plattformen Verbinden",
    kpi_tours: "Aktive Touren",
    kpi_clicks: "Link-Öffnungen",
    kpi_completions: "Abgeschlossen",
    kpi_conversion: "Conversion-Rate",
    chart_platforms_title: "Klicks nach Plattform",
    chart_platforms_sub: "Alle Touren zusammen",
    your_tours: "Deine Touren",
    view_all: "Alle ansehen",
    loading: "Lädt…",
    no_tours_yet: "Noch keine Touren.",
    create_first: "Erste erstellen",
    events_opens: "Öffnungen",
    events_completed: "abgeschlossen",

    tours_title: "Deine Touren",
    tours_subtitle: "Verwalte Touren und Bewertungs-Plattform-Links.",
    search_ph: "Suchen…",
    no_tours: "Keine Touren",
    no_tours_desc: "Erstelle deine erste Tour und erhalte einen eindeutigen Link für deine Kunden.",
    create_tour: "Tour erstellen",
    n_platforms: "{n} Plattformen",
    no_description: "Keine Beschreibung",
    copy_link_btn: "Link kopieren",
    toast_link_copied: "Link in Zwischenablage kopiert",
    toast_link_customer_copied: "Link kopiert! Sende ihn deinem Kunden.",
    del_confirm_title: "„{name}\" löschen?",
    del_confirm_desc: "Diese Aktion ist endgültig. Statistiken werden ebenfalls gelöscht.",
    cancel: "Abbrechen",
    delete: "Löschen",
    toast_tour_deleted: "Tour gelöscht",

    back_to_tours: "Zurück zu den Touren",
    new_tour_title: "Plattformen Verbinden",
    edit_tour_title: "Tour bearbeiten",
    copy_customer_link: "Kunden-Link kopieren",
    tour_name: "Tourname",
    tour_name_ph: "z. B. Amalfi Sonnenuntergang-Ausflug",
    tour_description: "Beschreibung (optional)",
    tour_description_ph: "Kurze Beschreibung für den Kunden…",
    platforms_title: "Links zu den Bewertungsplattformen",
    platforms_desc: "Füge die tour-spezifische Bewertungs-URL für jede Plattform ein. Leer lassen, um sie dem Kunden nicht zu zeigen.",
    smart_filter_title: "Smart Filter",
    smart_filter_desc: "Wenn der Kunde weniger Sterne als der Schwellenwert vergibt, wird er zu einem privaten Feedback-Formular umgeleitet, anstatt öffentlich zu posten.",
    smart_filter_label: "Mindestbewertung für öffentliches Posten",
    smart_filter_option: "{n}★ und mehr",
    smart_filter_hint_all: "Alle Bewertungen werden an die öffentlichen Plattformen gesendet.",
    smart_filter_hint: "Mit weniger als {n} Sternen sieht der Kunde nur das private Formular.",
    feedback_title: "Empfangenes privates Feedback",
    feedback_empty: "Noch kein privates Feedback. Wenn ein Kunde eine niedrige Bewertung hinterlässt, erscheint hier seine Nachricht.",
    how_it_works: "So funktioniert's",
    how_1: "Tour speichern und einzigartigen Link erhalten",
    how_2: "Sende ihn per WhatsApp, E-Mail oder SMS an den Kunden",
    how_3: "Der Kunde schreibt die Bewertung nur einmal",
    how_4: "Die App kopiert den Text und öffnet die Plattformen nacheinander",
    save_tour: "Tour speichern",
    saving: "Speichere…",
    toast_tour_created: "Tour erstellt!",
    toast_saved: "Gespeichert",
    name_required: "Tourname ist erforderlich",

    welcome_hi: "Hallo!",
    welcome_sub: "Danke, dass du dich für uns entschieden hast:",
    welcome_desc: "Hilf uns zu wachsen und hinterlasse eine Bewertung. Es dauert nur 60 Sekunden.",
    start: "Starten",
    step_write_title: "Schreibe deine Bewertung",
    step_write_desc: "Einmal schreiben. Auf allen Plattformen veröffentlichen.",
    placeholder: "Erzähle uns von deiner Erfahrung…",
    min_chars: "Mindestens 20 Zeichen",
    next: "Weiter",
    back: "Zurück",
    step_share_title: "Überall veröffentlichen",
    step_share_desc: "Tippe eine Plattform an. Dein Text wird automatisch kopiert – nur einfügen und posten.",
    copy_and_open: "Kopieren & öffnen",
    copied: "Text kopiert! Füge ihn in die Bewertung ein.",
    finish_title: "Vielen Dank!",
    finish_desc: "Dein Feedback macht für uns einen riesigen Unterschied.",
    done: "Fertig",
    no_platforms: "Für diese Tour sind noch keine Plattformen konfiguriert.",
    tour_not_found: "Tour nicht gefunden",
    published_ok: "Veröffentlicht",
    private_title: "Danke für dein Feedback",
    private_desc: "Wir möchten besser werden. Deine Nachricht bleibt privat und wird nicht online veröffentlicht.",
    private_email: "E-Mail (optional)",
    private_name: "Name (optional)",
    private_submit: "Privates Feedback senden",
    private_thanks: "Danke, dein Feedback wurde gesendet.",
    private_100: "100% privat",
    your_review: "Deine Bewertung",

    category_tour: "Tour",
    category_restaurant: "Restaurant",
    category_hotel: "Hotel",
    category_service: "Dienstleistung",
    restaurants_title: "Deine Restaurants",
    restaurants_subtitle: "Verwalte deine Restaurants und Bewertungs-Plattform-Links.",
    hotels_title: "Deine Hotels",
    hotels_subtitle: "Verwalte deine Hotels und Bewertungs-Plattform-Links.",
    services_title: "Deine Dienstleistungen",
    services_subtitle: "Verwalte deine Dienstleistungen und Bewertungs-Plattform-Links.",
    new_restaurant_btn: "Restaurant hinzufügen",
    new_hotel_btn: "Hotel hinzufügen",
    new_service_btn: "Dienstleistung hinzufügen",
    new_restaurant_title: "Neues Restaurant",
    new_hotel_title: "Neues Hotel",
    new_service_title: "Neue Dienstleistung",
    edit_restaurant_title: "Restaurant bearbeiten",
    edit_hotel_title: "Hotel bearbeiten",
    edit_service_title: "Dienstleistung bearbeiten",
    restaurant_name: "Name des Restaurants",
    hotel_name: "Name des Hotels",
    service_name: "Name der Dienstleistung",
    restaurant_name_ph: "z. B. Trattoria da Mario",
    hotel_name_ph: "z. B. Hotel Bellavista",
    service_name_ph: "z. B. Zahnarztpraxis Rossi",
    no_restaurants: "Keine Restaurants",
    no_hotels: "Keine Hotels",
    no_services: "Keine Dienstleistungen",
    no_restaurants_desc: "Erstelle dein erstes Restaurant und erhalte einen eindeutigen Link zum Sammeln von Bewertungen.",
    no_hotels_desc: "Erstelle dein erstes Hotel und erhalte einen eindeutigen Link zum Sammeln von Bewertungen.",
    no_services_desc: "Erstelle deine erste Dienstleistung und erhalte einen eindeutigen Link zum Sammeln von Bewertungen.",

    qr_code_btn: "QR-Code",
    qr_dialog_title: "QR-Code",
    qr_dialog_desc: "Drucke ihn aus oder zeige ihn dem Kunden, um Bewertungen zu sammeln.",
    qr_download_btn: "PNG herunterladen",
    qr_copy_link: "Link kopieren",

    auto_share_title: "Veröffentliche deine Bewertung",
    auto_share_desc: "Wir kopieren den Text und öffnen die Plattformen nacheinander. Einfach einfügen und auf jeder Veröffentlichen klicken.",
    auto_share_progress: "Plattform {current} von {total}",
    auto_share_open_now: "{platform} öffnen & veröffentlichen",
    auto_share_next: "Zur nächsten",
    auto_share_finish: "Fertig",
    auto_share_pasted_note: "Text in die Zwischenablage kopiert — füge ihn auf der Seite ein, die sich öffnet.",
    auto_share_start: "Veröffentlichung starten",
    auto_share_reopen: "{platform} erneut öffnen",
    auto_share_prev: "◀ Zurück",
    auto_share_jump: "Zu {platform}",
    finish_confirm_title: "Auf allen Plattformen veröffentlicht?",
    finish_confirm_desc: "Nicht markierte Plattformen erhalten deine Bewertung nicht. Du kannst zurückgehen.",
    finish_confirm_yes: "Ja, fertig",
    finish_confirm_back: "Nein, zurück",
    platform_visited: "Veröffentlicht",
    platform_not_visited: "Noch nicht veröffentlicht",
    auto_share_skip: "Diese Plattform überspringen",
    auto_share_login_warning: "⚠️ Falls die Seite nach einem Login fragt und hängen bleibt, tippe auf \"Überspringen\".",
    auto_share_google_tip: "💡 Google ist am einfachsten — du bist wahrscheinlich schon in deinem Google-Konto eingeloggt!",
  },
};

export function detectBrowserLang() {
  const nav = (typeof navigator !== "undefined" && navigator.language) || "en";
  const short = nav.slice(0, 2).toLowerCase();
  return translations[short] ? short : "en";
}

export function tr(lang, key, vars) {
  let s = (translations[lang] && translations[lang][key]) || translations.en[key] || key;
  if (vars) {
    Object.keys(vars).forEach((k) => {
      s = s.split(`{${k}}`).join(String(vars[k]));
    });
  }
  return s;
}

// Legacy shim: kept for /r/{tourId} which imports `t` from i18n
export function t(lang, key) {
  return tr(lang, key);
}
